/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Queuetype1Inputs */

const en_entity_queuetype1 = /** @type {(inputs: Entity_Queuetype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Type`)
};

const de_entity_queuetype1 = /** @type {(inputs: Entity_Queuetype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

/**
* | output |
* | --- |
* | "Queue Type" |
*
* @param {Entity_Queuetype1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_queuetype1 = /** @type {((inputs?: Entity_Queuetype1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Queuetype1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_queuetype1(inputs)
	return de_entity_queuetype1(inputs)
});
export { entity_queuetype1 as "entity_queueType" }